// Pick a localized field from a content doc; falls back to the base (English) value.
export function loc(obj, lang, field) {
  if (!obj) return '';
  const tr = obj.i18n && obj.i18n[lang];
  if (tr && tr[field] != null && tr[field] !== '') return tr[field];
  return obj[field] != null ? obj[field] : '';
}

// Localized sections array for Reims-style content.
export function locSections(obj, lang) {
  const tr = obj && obj.i18n && obj.i18n[lang] && obj.i18n[lang].sections;
  if (tr && tr.length) return tr;
  return (obj && obj.sections) || [];
}

// Pick a localized value from a {en, fr, lv, ru} map; falls back to en.
export function pick(map, lang) {
  if (!map) return null;
  if (map[lang] != null && map[lang] !== '') return map[lang];
  return map.en != null ? map.en : null;
}
